import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { enums } from "../lib";

/**
 * Use Group Id Hook
 */
export default () => {
    const { organisationSettings, settings } = useSelector(
        (state) => state.typesList
    );

    const isSignatureRequired = useMemo(() => {
        const signatureSetting =
            settings &&
            settings.data.find(
                (item) => item.id === enums.status.settings.signatureRequired
            );
        const organisationSettingsId =
            organisationSettings &&
            organisationSettings.data.find(
                (item) => item.settingId === signatureSetting.id
            );

        if (organisationSettingsId) {
            return Boolean(organisationSettingsId.value);
        } else return false;
    }, [organisationSettings, settings]);

    return isSignatureRequired;
};
